'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What is a landing page and why do I need one?",
    answer: "A landing page is a standalone web page designed to promote a product, service, or campaign. It helps drive conversions by focusing the visitor’s attention on a specific goal like sign-ups, inquiries, or purchases."
  },
  {
    question: "Do you design landing pages for specific platforms or ads?",
    answer: "Yes, we create landing pages tailored for Google Ads, Facebook campaigns, email marketing, and more. Each page is optimized to match your campaign goals and maximize conversions."
  },
  {
    question: "How long does it take to develop a landing page?",
    answer: "Most landing pages are completed within 2–5 days depending on the complexity, design requirements, and content availability. We also offer express delivery for urgent campaigns."
  },
  {
    question: "Will the landing page be mobile-friendly and fast-loading?",
    answer: "Absolutely. Every landing page we build is fully responsive, fast-loading, and optimized for both mobile and desktop. We prioritize performance and user experience to reduce bounce rates and increase engagement."
  },
  {
    question: "Can you integrate forms, payment options, or analytics?",
    answer: "Yes, we can integrate lead capture forms, payment gateways, WhatsApp/chat support, Google Analytics, and Facebook Pixel — everything you need to track and grow your campaign effectively."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center py-5 mt-5' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <span
                        className={`transition-colors duration-200 cursor-pointer 
                          hover:text-purple-600 
                          ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                      >{item.question}</span>
                     </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
